import floatingPanelEngine from '../../Core/FloatingPanelEngine';
import noteOptionsPanelEngine from '../../../NoteOptionsPanel/Core/NoteOptionsPanelEngine';
import commandEngine from './CommandEngine';

/**
 * Registers the /focus command with the CommandEngine.
 * Call once at module load from YourLibraryTab.
 *
 * /focus off — exits focus mode on all open panels
 * /focus on  — enters focus mode on all open panels; selects first result if no entry selected
 */
export function registerFocusCommand() {
    commandEngine.register('/focus', {
        hint: 'Toggle focus mode',
        params: [
            { name: 'on',  hint: 'on' },
            { name: 'off', hint: 'off' },
        ],
        handler: ([mode]) => {
            if (mode === 'off') {
                floatingPanelEngine.clearAllFocusMode();
                return;
            }

            if (mode === 'on') {
                const panels = floatingPanelEngine.getPanels();
                if (!panels.length) return;

                for (const p of panels) {
                    const provider = p.provider;
                    let entry = provider.getSelectedEntry();

                    // No entry selected — try first result
                    if (!entry) {
                        const results = provider.getResults();
                        if (!results.length) {
                            noteOptionsPanelEngine.exitFocus(p.rk);
                            continue;
                        }
                        entry = results[0];
                        provider.selectEntry(entry);
                    }

                    noteOptionsPanelEngine.enterFocus(p.rk);
                }
            }
        },
    });
}
